import React from 'react';

const CustomerSupport: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20C0 17.7477 1.74772 16 4 16H10C12.2523 16 14 17.7477 14 20V23C14 23.5523 13.5523 24 13 24H1C0.447715 24 0 23.5523 0 23V20ZM4 18C2.85228 18 2 18.8523 2 20V22H12V20C12 18.8523 11.1477 18 10 18H4Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 8C5.85228 8 5 8.85228 5 10V11C5 12.1477 5.85228 13 7 13C8.14772 13 9 12.1477 9 11V10C9 8.85228 8.14772 8 7 8ZM3 10C3 7.74772 4.74772 6 7 6C9.25229 6 11 7.74772 11 10V11C11 13.2523 9.25229 15 7 15C4.74772 15 3 13.2523 3 11V10Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C12 0.447715 12.4477 0 13 0H23C23.5523 0 24 0.447715 24 1V8C24 8.55228 23.5523 9 23 9H17.3333L13.6 11.8C13.297 12.0273 12.8916 12.0638 12.5528 11.8944C12.214 11.725 12 11.3788 12 11V1ZM14 2V9L16.4 7.2C16.5731 7.07018 16.7836 7 17 7H22V2H14Z"
      />
    </svg>
  );
};

export default CustomerSupport;
